import { createFeatureSelector, createSelector } from '@ngrx/store';
// import { HttpStatus } from '@core/classes/http-status.class';
import { HttpErrorResponse } from '@angular/common/http';

// import * as Objects from '@core/objects';
import { RecordingConfig } from '@core/models/recording-config.model';
import { NotificationData } from "@core/store/models/notifications.interface";
import { Record } from '@core/store/models/recorder.class';

/**
 * the status from the store allow modals show depending on them, be careful updating names
 */

export enum RecorderStatus { 
    INITIAL = 0,
    STARTING = 1,
    STARTED = 2,
    STARTED_SCREEN_ONLY = 3, // to avoid pip modal
    RECORDING = 4,
    RECORDING_SCREEN_ONLY = 5, // to avoid pip modal
    STOPPED = 6,
    FAILED = 7,
    FINISHED_SUCCESS = 8, // should be triggered when all ends OK.
    FINISHED_ERROR = 9 // should be triggered when all ends OK.
}

export interface Recorder {
    status:RecorderStatus;
    config: RecordingConfig;
    notificationData: NotificationData;
    recordData: Record;
    streamChunks: Blob[];
    mediaRecorder: MediaRecorder | null;
}

export const initialState: Recorder = {
    status: RecorderStatus.INITIAL,
    config: {
        selectedMicId: '',
        selectedCamId: '',
        selectedScreenRecording: true
    },
    notificationData: null,
    recordData: null,
    streamChunks: [],
    mediaRecorder: null,
};

const recorderFeatureSelector = createFeatureSelector('recorder');

// Selectors
export const recorderSelector = createSelector(
    recorderFeatureSelector,
    (state: Recorder) => state
);

export const configSelector = createSelector(
    recorderFeatureSelector,
    (state: Recorder) => state.config
);

export const recordDataSelector = createSelector(
    recorderFeatureSelector,
    (state: Recorder) => state.recordData
);

export const notificationDataSelector = createSelector(
    recorderFeatureSelector,
    (state: Recorder) => state.notificationData
);

export const statusSelector = createSelector(
    recorderFeatureSelector,
    (state: Recorder) => state.status
);

export const mediaRecorderSelector = createSelector(
    recorderFeatureSelector,
    (state: Recorder) => state.mediaRecorder
);

export const chunksSelector = createSelector(
    recorderFeatureSelector,
    (state: Recorder) => state.streamChunks
);